"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[9819],{

/***/ 68489:
/***/ ((module) => {



module.exports = function () {
  // https://mths.be/emoji
  return /\uD83C\uDFF4(?:\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\u200D\u2620\uFE0F)|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\uD83D\uDC68(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDB0-\uDDB3])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDB5\uDDB6\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF9]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD70\uDD73-\uDD76\uDD7A\uDD7C-\uDDA2\uDDB0-\uDDB9\uDDC0-\uDDC2\uDDD0-\uDDFF])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDB5\uDDB6\uDDB8\uDDB9\uDDD1-\uDDDD])/g;
};


/***/ }),

/***/ 24654:
/***/ ((module) => {



module.exports = function encodeUtf8 (input) {
  var result = []
  var size = input.length

  for (var index = 0; index < size; index++) {
    var point = input.charCodeAt(index)

    if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
      var second = input.charCodeAt(index + 1)

      if (second >= 0xDC00 && second <= 0xDFFF) {
        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000
        index += 1
      }
    }

    // US-ASCII
    if (point < 0x80) {
      result.push(point)
      continue
    }

    // 2-byte UTF-8
    if (point < 0x800) {
      result.push((point >> 6) | 192)
      result.push((point & 63) | 128)
      continue
    }

    // 3-byte UTF-8
    if (point < 0xD800 || (point >= 0xE000 && point < 0x10000)) {
      result.push((point >> 12) | 224)
      result.push(((point >> 6) & 63) | 128)
      result.push((point & 63) | 128)
      continue
    }

    // 4-byte UTF-8
    if (point >= 0x10000 && point <= 0x10FFFF) {
      result.push((point >> 18) | 240)
      result.push(((point >> 12) & 63) | 128)
      result.push(((point >> 6) & 63) | 128)
      result.push((point & 63) | 128)
      continue
    }

    // Invalid character
    result.push(0xEF, 0xBF, 0xBD)
  }

  return new Uint8Array(result).buffer
}


/***/ }),

/***/ 52086:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const capabilities_1 = __webpack_require__(52585);
const Bematech_1 = __webpack_require__(13167);
const Epson_1 = __webpack_require__(13078);
const ControliD_1 = __webpack_require__(65955);
const Daruma_1 = __webpack_require__(97642);
const Dataregis_1 = __webpack_require__(91313);
const Diebold_1 = __webpack_require__(77096);
const Elgin_1 = __webpack_require__(75349);
const Generic_1 = __webpack_require__(85037);
const Perto_1 = __webpack_require__(21017);
const Sweda_1 = __webpack_require__(93429);
const cache = new Map();
class Model {
    constructor(model) {
        if (typeof model === 'string') {
            this._profile = Model.initialiseProfile(Model.EXPAND(Model.FIND(model)));
        }
        else {
            this._profile = model;
        }
    }
    static initialiseProfile(capability) {
        switch (capability.profile) {
            case 'bematech':
                return new Bematech_1.default(capability);
            case 'controlid':
                return new ControliD_1.default(capability);
            case 'daruma':
                return new Daruma_1.default(capability);
            case 'dataregis':
                return new Dataregis_1.default(capability);
            case 'diebold':
                return new Diebold_1.default(capability);
            case 'elgin':
                return new Elgin_1.default(capability);
            case 'generic':
                return new Generic_1.default(capability);
            case 'perto':
                return new Perto_1.default(capability);
            case 'sweda':
                return new Sweda_1.default(capability);
            default:
                return new Epson_1.default(capability);
        }
    }
    static ASSIGN_DEFINED(target, ...others) {
        others.forEach((other) => {
            Object.keys(other).forEach((key) => {
                if (other[key] !== undefined) {
                    target[key] = other[key];
                }
            });
        });
        return target;
    }
    static FIND(model) {
        const profile = capabilities_1.default.models.find((profile) => profile['model'] == model);
        if (!profile) {
            throw new Error(`Printer model "${model}" not supported`);
        }
        return profile;
    }
    static EXPAND(profile) {
        const capability = {
            model: undefined,
            profile: undefined,
            brand: undefined,
            columns: undefined,
            fonts: undefined,
            codepage: undefined,
            codepages: undefined,
        };
        if (cache.has(profile['model'])) {
            return cache.get(profile['model']);
        }
        Model.ASSIGN_DEFINED(capability, Model.ASSIGN_DEFINED({}, profile, capability));
        while ('profile' in profile) {
            profile = capabilities_1.default.profiles[profile['profile']];
            Model.ASSIGN_DEFINED(capability, Model.ASSIGN_DEFINED({}, profile, capability));
        }
        capability.codepages = Object.keys(capability.codepages).map((code) => ({
            code,
            command: capability.codepages[code],
        }));
        cache.set(capability.model, capability);
        return capability;
    }
    static ALL() {
        return capabilities_1.default.models.map((profile) => Model.EXPAND(profile));
    }
    get name() {
        return this._profile.name;
    }
    get profile() {
        return this._profile;
    }
}
exports["default"] = Model;
//# sourceMappingURL=Model.js.map

/***/ }),

/***/ 84309:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
const Model_1 = __webpack_require__(52086);
const actions_1 = __webpack_require__(48960);
class Printer {
    constructor(model) {
        this.model = model;
    }
    setCodepage(value) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.model.profile.setCodepage(value);
        });
    }
    buzzer() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.model.profile.buzzer();
        });
    }
    cutter(mode = actions_1.Cut.Partial) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.model.profile.cutter(mode);
        });
    }
    drawer(number = actions_1.Drawer.First, on_time = 120, off_time = 240) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.model.profile.drawer(number, on_time, off_time);
        });
    }
    draw(image) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.model.profile.draw(image);
        });
    }
    qrcode(data, size = null) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.model.profile.qrcode(data, size);
        });
    }
    setAlignment(align) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.model.profile.setAlignment(align);
        });
    }
    write(text, styles = 0) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.model.profile.write(text, styles);
        });
    }
    writeln(text = '', styles = 0, align = actions_1.Align.Left) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.model.profile.writeln(text, styles, align);
        });
    }
    withStyle(styleConf, cb) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.model.profile.withStyle(styleConf, cb);
        });
    }
    feed(lines = 1) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.model.profile.feed(lines);
        });
    }
    get columns() {
        return this.model.profile.columns;
    }
    setColumns(value) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.model.profile.setColumns(value);
        });
    }
    close() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.model.profile.finalize();
        });
    }
    static CONNECT(_model, connection) {
        var _a, _b;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let model;
            if (typeof _model === 'string') {
                model = new Model_1.default(_model);
            }
            else {
                model = _model;
            }
            yield connection.open();
            model.profile.connection = connection;
            yield ((_b = (_a = model.profile).initialize) === null || _b === void 0 ? void 0 : _b.call(_a));
            return new Printer(model);
        });
    }
}
exports["default"] = Printer;
//# sourceMappingURL=Printer.js.map

/***/ }),

/***/ 48960:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var Align;
(function (Align) {
    Align[Align["Left"] = 0] = "Left";
    Align[Align["Center"] = 1] = "Center";
    Align[Align["Right"] = 2] = "Right";
})(Align = exports.Align || (exports.Align = {}));
var Cut;
(function (Cut) {
    Cut[Cut["Full"] = 0] = "Full";
    Cut[Cut["Partial"] = 1] = "Partial";
})(Cut = exports.Cut || (exports.Cut = {}));
var Drawer;
(function (Drawer) {
    Drawer[Drawer["First"] = 0] = "First";
    Drawer[Drawer["Second"] = 1] = "Second";
})(Drawer = exports.Drawer || (exports.Drawer = {}));
var Style;
(function (Style) {
    Style[Style["Bold"] = 1] = "Bold";
    Style[Style["Italic"] = 2] = "Italic";
    Style[Style["Underline"] = 4] = "Underline";
    Style[Style["Condensed"] = 8] = "Condensed";
    Style[Style["DoubleWidth"] = 16] = "DoubleWidth";
    Style[Style["DoubleHeight"] = 32] = "DoubleHeight";
})(Style = exports.Style || (exports.Style = {}));
//# sourceMappingURL=actions.js.map

/***/ }),

/***/ 52585:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const capabilities = {
    models: [
        {
            model: 'MP-4200 TH',
            profile: 'bematech',
        },
        {
            model: 'MP-2800 TH',
            profile: 'bematech',
            columns: 48,
            feed: 4,
            fonts: [
                {
                    name: 'Font A',
                    columns: 48,
                },
                {
                    name: 'Font B',
                    columns: 64,
                },
            ],
        },
        {
            model: 'MP-2500 TH',
            profile: 'bematech',
            feed: 6,
        },
        {
            model: 'MP-2100 TH',
            profile: 'bematech',
            feed: 6,
        },
        {
            model: 'MP-4000 TH',
            profile: 'bematech',
        },
        {
            model: 'MP-5100 TH',
            profile: 'bematech',
        },
        {
            model: 'MP-100S TH',
            profile: 'bematech',
        },
        {
            model: 'MP-20 MI',
            profile: 'bematech',
        },
        {
            model: 'TM-T20',
            profile: 'epson',
            columns: 48,
            fonts: [
                {
                    name: 'Font 1',
                    columns: 42,
                },
                {
                    name: 'Font A',
                    columns: 48,
                },
                {
                    name: 'Font 2',
                    columns: 60,
                },
                {
                    name: 'Font B',
                    columns: 64,
                },
            ],
        },
        {
            model: 'TM-T81',
            profile: 'epson',
        },
        {
            model: 'TM-T88',
            profile: 'epson',
        },
        {
            model: 'I9',
            profile: 'elgin',
            columns: 48,
            feed: 4,
            fonts: [
                {
                    name: 'Font A',
                    columns: 48,
                },
                {
                    name: 'Font B',
                    columns: 64,
                },
            ],
        },
        {
            model: 'I7',
            profile: 'elgin',
        },
        {
            model: 'VOX',
            profile: 'elgin',
        },
        {
            model: 'VOX+',
            profile: 'elgin',
        },
        {
            model: 'NIX',
            profile: 'elgin',
        },
        {
            model: 'DR800',
            profile: 'daruma',
            feed: 2,
        },
        {
            model: 'DR700',
            profile: 'daruma',
        },
        {
            model: 'DR600',
            profile: 'daruma',
        },
        {
            model: 'DS348',
            profile: 'daruma',
        },
        {
            model: 'DS300',
            profile: 'daruma',
        },
        {
            model: 'TSP-143',
            profile: 'diebold',
        },
        {
            model: 'IM453',
            profile: 'diebold',
        },
        {
            model: 'IM433',
            profile: 'diebold',
        },
        {
            model: 'IM402',
            profile: 'diebold',
        },
        {
            model: 'IM113',
            profile: 'diebold',
        },
        {
            model: 'IM833',
            profile: 'diebold',
            name: 'Mecaf Perfecta',
        },
        {
            model: 'SI-300L',
            profile: 'sweda',
        },
        {
            model: 'SI-300S',
            profile: 'sweda',
        },
        {
            model: 'SI-300W',
            profile: 'sweda',
        },
        {
            model: 'SI-250',
            profile: 'sweda',
        },
        {
            model: 'E-3202',
            profile: 'dataregis',
        },
        {
            model: 'DT200',
            profile: 'dataregis',
        },
        {
            model: 'PrintiD',
            profile: 'controlid',
            name: 'Print iD',
        },
        {
            model: 'PrintiD-Touch',
            profile: 'controlid',
            name: 'Print iD Touch',
        },
        {
            model: 'PertoPrinter',
            profile: 'perto',
            name: 'Perto Printer',
        },
        {
            model: 'CMP-20',
            profile: 'generic',
            brand: 'Citizen',
        },
        {
            model: 'POS-80',
            profile: 'generic',
            columns: 48,
            fonts: [
                {
                    name: 'Font A',
                    columns: 48,
                },
                {
                    name: 'Font B',
                    columns: 56,
                },
            ],
        },
        {
            model: 'POS-58',
            profile: 'generic',
        },
    ],
    profiles: {
        epson: {
            brand: 'Epson',
            columns: 42,
            feed: 3,
            codepage: 'cp850',
            fonts: [
                {
                    name: 'Font A',
                    columns: 42,
                },
                {
                    name: 'Font B',
                    columns: 56,
                },
            ],
            codepages: {
                cp437: '\x1Bt\x00',
                cp930: '\x1Bt\x01',
                cp850: '\x1Bt\x02',
                cp860: '\x1Bt\x03',
                cp863: '\x1Bt\x04',
                cp865: '\x1Bt\x05',
                cp1252: '\x1Bt\x10',
                cp866: '\x1Bt\x11',
                cp852: '\x1Bt\x12',
                cp858: '\x1Bt\x13',
            },
        },
        bematech: {
            brand: 'Bematech',
            columns: 50,
            feed: 0,
            codepage: 'cp850',
            fonts: [
                {
                    name: 'Font A',
                    columns: 42,
                },
                {
                    name: 'Font C',
                    columns: 50,
                },
                {
                    name: 'Font B',
                    columns: 56,
                },
            ],
            initialize: '\x1D\xf950',
            codepages: {
                cp850: '\x1Bt\x02',
                cp437: '\x1Bt\x03',
                cp860: '\x1Bt\x04',
                cp858: '\x1Bt\x05',
                cp866: '\x1Bt\x06',
                cp864: '\x1Bt\x07',
                utf8: '\x1Bt\x08',
                big5e: '\x1Bt\x09',
                jis: '\x1Bt\x0a',
                shiftjis: '\x1Bt\x0b',
                gb2312: '\x1Bt\x0c',
            },
        },
        elgin: {
            profile: 'epson',
            brand: 'Elgin',
            feed: 2,
            codepages: {
                cp1252: '\x1Bt\x01',
                cp850: '\x1Bt\x02',
                cp437: '\x1Bt\x03',
                cp860: '\x1Bt\x04',
                cp858: '\x1Bt\x05',
            },
        },
        sweda: {
            profile: 'elgin',
            feed: 8,
            brand: 'Sweda',
        },
        dataregis: {
            profile: 'elgin',
            brand: 'Dataregis',
        },
        daruma: {
            brand: 'Daruma',
            profile: 'epson',
            columns: 48,
            feed: 8,
            codepage: 'cp1252',
            fonts: [
                {
                    name: 'Font A',
                    columns: 48,
                },
                {
                    name: 'Font B',
                    columns: 52,
                },
            ],
            codepages: {
                iso88591: '\x1Bt\x01',
                cp850: '\x1Bt\x02',
                cp1252: '\x1Bt\x03',
                cp437: '\x1Bt\x04',
            },
        },
        diebold: {
            brand: 'Diebold',
            profile: 'daruma',
            codepages: {
                cp1252: '\x1Bt\x01',
                cp850: '\x1Bt\x02',
                cp437: '\x1Bt\x03',
            },
        },
        controlid: {
            profile: 'epson',
            brand: 'ControliD',
            columns: 48,
            feed: 0,
            fonts: [
                {
                    name: 'Font C',
                    columns: 48,
                },
                {
                    name: 'Font A',
                    columns: 48,
                },
                {
                    name: 'Font B',
                    columns: 64,
                },
            ],
        },
        perto: {
            profile: 'elgin',
            brand: 'Perto',
            columns: 48,
            codepage: 'cp850',
            fonts: [
                {
                    name: 'Font A',
                    columns: 48,
                },
                {
                    name: 'Font B',
                    columns: 57,
                },
            ],
        },
        generic: {
            brand: 'Generic',
            codepage: 'cp850',
            columns: 32,
            fonts: [
                {
                    name: 'Font A',
                    columns: 32,
                },
                {
                    name: 'Font B',
                    columns: 42,
                },
            ],
            initialize: '\x1BR\x0C',
            codepages: {
                cp437: '\x1Bt\x00',
                cp930: '\x1Bt\x01',
                cp850: '\x1Bt\x02',
                cp860: '\x1Bt\x03',
                cp863: '\x1Bt\x04',
                cp865: '\x1Bt\x05',
                cp1252: '\x1Bt\x06',
                cp866: '\x1Bt\x07',
                cp852: '\x1Bt\x08',
                cp858: '\x1Bt\x09',
                cp1253: '\x1Bt\x0A',
                cp737: '\x1Bt\x0B',
                cp857: '\x1Bt\x0C',
                iso88599: '\x1Bt\x0D',
                cp864: '\x1Bt\x0E',
                cp862: '\x1Bt\x0F',
                iso88592: '\x1Bt\x10',
            },
        },
    },
};
exports["default"] = capabilities;
//# sourceMappingURL=capabilities.js.map

/***/ }),

/***/ 951:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
class InMemory {
    open() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.list = [];
        });
    }
    write(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.list.push(data);
        });
    }
    close() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () { });
    }
    buffer() {
        return Buffer.concat(this.list);
    }
}
exports["default"] = InMemory;
//# sourceMappingURL=InMemory.js.map

/***/ }),

/***/ 62133:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
class WebUSB {
    constructor(device) {
        this.device = device;
        this.endpointNumber = 1;
    }
    open({ configuration = 1, interface: interfaceNumber = 0, } = {}) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.device.open();
            yield this.device.selectConfiguration(configuration);
            yield this.device.claimInterface(interfaceNumber);
            const iface = this.device.configuration.interfaces[interfaceNumber];
            const endpoint = iface.alternate.endpoints.find((e) => e.direction === 'out');
            this.endpointNumber = endpoint.endpointNumber;
        });
    }
    write(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.device.transferOut(this.endpointNumber, data);
        });
    }
    close() {
        return this.device.close();
    }
}
exports["default"] = WebUSB;
//# sourceMappingURL=WebUSB.js.map

/***/ }),

/***/ 10086:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var InMemory_1 = __webpack_require__(951);
exports.InMemory = InMemory_1.default;
var WebUSB_1 = __webpack_require__(62133);
exports.WebUSB = WebUSB_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 37043:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
const filter_1 = __webpack_require__(83772);
const fs = __webpack_require__(36510);
const pngjs_1 = __webpack_require__(8871);
class Image {
    constructor(input = null, filter = new filter_1.FloydSteinberg()) {
        if (input instanceof pngjs_1.PNG) {
            this.readImage(filter.process(input));
        }
        else if (typeof input === 'string') {
            this.loadImage(input, filter);
        }
        else if (input) {
            this.loadImageData(input, filter);
        }
    }
    loadImage(filename, filter) {
        const data = fs.readFileSync(filename);
        this.loadImageData(data, filter);
    }
    loadImageData(data, filter) {
        const png = pngjs_1.PNG.sync.read(data);
        const image = filter.process(png);
        this.readImage(image);
    }
    readImage(image) {
        const width = image.width;
        const img_height = image.height;
        const bits = 24;
        const slices = Math.trunc(bits / 8);
        const height = Math.trunc((img_height + bits - 1) / bits) * bits;
        this.width = width;
        this.bytesPerRow = slices * width;
        this.lines = Math.trunc(height / bits);
        let pos = 0;
        const data = Buffer.alloc((width * height) / 8);
        for (let offset_y = 0; offset_y < img_height; offset_y += bits) {
            for (let img_x = 0; img_x < width; img_x++) {
                for (let s = 0; s < slices; s++) {
                    let slice = 0b00000000;
                    for (let bit = 0; bit < 8; bit++) {
                        const img_y = offset_y + s * 8 + bit;
                        if (img_y >= img_height) {
                            break;
                        }
                        const src_red = image.data[img_y * width * 4 + img_x * 4 + 0];
                        const src_green = image.data[img_y * width * 4 + img_x * 4 + 1];
                        const src_blue = image.data[img_y * width * 4 + img_x * 4 + 2];
                        const src_alpha = image.data[img_y * width * 4 + img_x * 4 + 3];
                        const bkg_red = 0xff;
                        const bkg_green = 0xff;
                        const bkg_blue = 0xff;
                        const alpha = src_alpha / 0xff;
                        const red = alpha * src_red + (1 - alpha) * bkg_red;
                        const green = alpha * src_green + (1 - alpha) * bkg_green;
                        const blue = alpha * src_blue + (1 - alpha) * bkg_blue;
                        const greyness = Math.trunc(red * 0.3 + green * 0.59 + blue * 0.11) >> 7;
                        const dot = 1 - greyness;
                        slice |= dot << (7 - bit);
                    }
                    data[pos] = slice;
                    pos++;
                }
            }
        }
        this.data = data;
    }
    lineData(index) {
        const start = index * this.bytesPerRow;
        return this.data.slice(start, start + this.bytesPerRow);
    }
}
exports["default"] = Image;
//# sourceMappingURL=Image.js.map

/***/ }),

/***/ 21144:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
class BayerOrdered {
    process(image) {
        const width = image.width;
        const height = image.height;
        const new_data = image.data.slice();
        const pattern = [
            [15, 195, 60, 240],
            [135, 75, 180, 120],
            [45, 225, 30, 210],
            [165, 105, 150, 90],
        ];
        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                const red = image.data[y * width * 4 + x * 4 + 0];
                const green = image.data[y * width * 4 + x * 4 + 1];
                const blue = image.data[y * width * 4 + x * 4 + 2];
                const alpha = image.data[y * width * 4 + x * 4 + 3];
                const greyness = Math.trunc(red * 0.3 + green * 0.59 + blue * 0.11);
                const threshold = pattern[y % 4][x % 4];
                const grey = (greyness + threshold) >> 1;
                const new_color = grey > 127 ? 0xff : 0;
                new_data[y * width * 4 + x * 4 + 0] = new_color;
                new_data[y * width * 4 + x * 4 + 1] = new_color;
                new_data[y * width * 4 + x * 4 + 2] = new_color;
                new_data[y * width * 4 + x * 4 + 3] = alpha;
            }
        }
        image.data = new_data;
        return image;
    }
}
exports["default"] = BayerOrdered;
//# sourceMappingURL=BayerOrdered.js.map

/***/ }),

/***/ 30713:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
class FloydSteinberg {
    process(image) {
        const width = image.width;
        const height = image.height;
        const new_data = image.data.slice();
        const pixel = new Map();
        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                const red = image.data[y * width * 4 + x * 4 + 0];
                const green = image.data[y * width * 4 + x * 4 + 1];
                const blue = image.data[y * width * 4 + x * 4 + 2];
                const alpha = image.data[y * width * 4 + x * 4 + 3];
                let grey = Math.trunc(red * 0.3 + green * 0.59 + blue * 0.11);
                if (pixel.has(`${x}_${y}`)) {
                    grey += pixel.get(`${x}_${y}`);
                }
                const new_color = grey > 127 ? 0xff : 0;
                new_data[y * width * 4 + x * 4 + 0] = new_color;
                new_data[y * width * 4 + x * 4 + 1] = new_color;
                new_data[y * width * 4 + x * 4 + 2] = new_color;
                new_data[y * width * 4 + x * 4 + 3] = alpha;
                const error = grey - (new_color & 0xff);
                if (x + 1 < width) {
                    const prev = pixel.has(`${x + 1}_${y}`)
                        ? pixel.get(`${x + 1}_${y}`)
                        : 0;
                    const value = prev + ((error * 7) >> 4);
                    pixel.set(`${x + 1}_${y}`, value);
                }
                if (y == height - 1) {
                    continue;
                }
                if (x > 0) {
                    const prev = pixel.get(`${x - 1}_${y + 1}`);
                    pixel.set(`${x - 1}_${y + 1}`, prev + ((error * 3) >> 4));
                }
                const prev = pixel.has(`${x}_${y + 1}`)
                    ? pixel.get(`${x}_${y + 1}`)
                    : 0;
                pixel.set(`${x}_${y + 1}`, prev + ((error * 5) >> 4));
                if (x < width - 1) {
                    pixel.set(`${x + 1}_${y + 1}`, 0 + ((error * 1) >> 4));
                }
            }
        }
        image.data = new_data;
        return image;
    }
}
exports["default"] = FloydSteinberg;
//# sourceMappingURL=FloydSteinberg.js.map

/***/ }),

/***/ 76172:
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
class Threshold {
    process(image) {
        const width = image.width;
        const height = image.height;
        const new_data = image.data.slice();
        for (let y = 0; y < height; y++) {
            for (let x = 0; x < width; x++) {
                const red = image.data[y * width * 4 + x * 4 + 0];
                const green = image.data[y * width * 4 + x * 4 + 1];
                const blue = image.data[y * width * 4 + x * 4 + 2];
                const alpha = image.data[y * width * 4 + x * 4 + 3];
                const grey = Math.trunc(red * 0.3 + green * 0.59 + blue * 0.11);
                const new_color = grey > 127 ? 0xff : 0;
                new_data[y * width * 4 + x * 4 + 0] = new_color;
                new_data[y * width * 4 + x * 4 + 1] = new_color;
                new_data[y * width * 4 + x * 4 + 2] = new_color;
                new_data[y * width * 4 + x * 4 + 3] = alpha;
            }
        }
        image.data = new_data;
        return image;
    }
}
exports["default"] = Threshold;
//# sourceMappingURL=Threshold.js.map

/***/ }),

/***/ 83772:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var Threshold_1 = __webpack_require__(76172);
exports.Threshold = Threshold_1.default;
var BayerOrdered_1 = __webpack_require__(21144);
exports.BayerOrdered = BayerOrdered_1.default;
var FloydSteinberg_1 = __webpack_require__(30713);
exports.FloydSteinberg = FloydSteinberg_1.default;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 46721:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
tslib_1.__exportStar(__webpack_require__(48960), exports);
tslib_1.__exportStar(__webpack_require__(10086), exports);
var Model_1 = __webpack_require__(52086);
exports.Model = Model_1.default;
var Image_1 = __webpack_require__(37043);
exports.Image = Image_1.default;
tslib_1.__exportStar(__webpack_require__(83772), exports);
tslib_1.__exportStar(__webpack_require__(84309), exports);
var Printer_1 = __webpack_require__(84309);
exports.Printer = Printer_1.default;
var pngjs_1 = __webpack_require__(8871);
exports.PNG = pngjs_1.PNG;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 13167:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
const Epson_1 = __webpack_require__(13078);
const actions_1 = __webpack_require__(48960);
class Bematech extends Epson_1.default {
    setStyle(style, enable) {
        const _super = Object.create(null, {
            setStyle: { get: () => super.setStyle }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.font.name != 'Font C') {
                return _super.setStyle.call(this, style, enable);
            }
            if (enable) {
                if (actions_1.Style.Bold == style) {
                    return this.connection.write(Buffer.from('\x1BE', 'ascii'));
                }
            }
            else {
                if (actions_1.Style.Bold == style) {
                    return this.connection.write(Buffer.from('\x1BF', 'ascii'));
                }
            }
            return _super.setStyle.call(this, style, enable);
        });
    }
    buzzer() {
        const _super = Object.create(null, {
            buzzer: { get: () => super.buzzer }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.capabilities.model == 'MP-2800 TH') {
                return this.connection.write(Buffer.from('\x1BB\x02\x01', 'ascii'));
            }
            else if (this.font.name != 'Font C') {
                return this.connection.write(Buffer.from('\x1B(A\x05\x00ad\x02\x02\x01', 'ascii'));
            }
            else {
                return _super.buzzer.call(this);
            }
        });
    }
    drawer(number, on_time, off_time) {
        const _super = Object.create(null, {
            drawer: { get: () => super.drawer }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.font.name != 'Font C') {
                return _super.drawer.call(this, number, on_time, off_time);
            }
            const index = {
                [actions_1.Drawer.First]: 'v',
                [actions_1.Drawer.Second]: '\x80',
            };
            const on_time_char = String.fromCharCode(Math.max(Math.min(on_time, 255), 50));
            return this.connection.write(Buffer.from('\x1B' + index[number] + on_time_char, 'ascii'));
        });
    }
    qrcode(data, size) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const len = data.length + 3;
            const pL = String.fromCharCode(len & 0xff);
            const pH = String.fromCharCode((len >> 8) & 0xff);
            const error = String.fromCharCode(2);
            const _size = String.fromCharCode(Math.min(11, Math.max(1, size || 4)) * 2);
            const version = String.fromCharCode(0);
            const encoding = String.fromCharCode(1);
            yield this.connection.write(Buffer.from('\x1DkQ', 'ascii'));
            yield this.connection.write(Buffer.from(error + _size + version + encoding, 'ascii'));
            yield this.connection.write(Buffer.from(pL + pH, 'ascii'));
            yield this.connection.write(Buffer.from(data, 'ascii'));
            yield this.connection.write(Buffer.from('\x00', 'ascii'));
            return this.feed(1);
        });
    }
    fontChanged(current, previows) {
        const _super = Object.create(null, {
            fontChanged: { get: () => super.fontChanged }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (current.name == 'Font C') {
                return this.connection.write(Buffer.from('\x1D\xf950', 'ascii'));
            }
            yield this.connection.write(Buffer.from('\x1D\xf951', 'ascii'));
            return _super.fontChanged.call(this, current, previows);
        });
    }
}
exports["default"] = Bematech;
//# sourceMappingURL=Bematech.js.map

/***/ }),

/***/ 65955:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
const Epson_1 = __webpack_require__(13078);
const actions_1 = __webpack_require__(48960);
class ControliD extends Epson_1.default {
    setStyle(style, enable) {
        const _super = Object.create(null, {
            setStyle: { get: () => super.setStyle }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (enable) {
                if (actions_1.Style.Bold == style) {
                    return this.connection.write(Buffer.from('\x1BE\x01', 'ascii'));
                }
            }
            else {
                if (actions_1.Style.Bold == style) {
                    return this.connection.write(Buffer.from('\x1BE\x00', 'ascii'));
                }
            }
            return _super.setStyle.call(this, style, enable);
        });
    }
    qrcode(data, size) {
        const _super = Object.create(null, {
            qrcode: { get: () => super.qrcode }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.capabilities.model == 'PrintiD-Touch') {
                return _super.qrcode.call(this, data, size);
            }
            else {
                return this.drawQrcode(data, size);
            }
        });
    }
    initialize() {
        const _super = Object.create(null, {
            initialize: { get: () => super.initialize }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield _super.initialize.call(this);
            return this.fontChanged(this.font, this.font);
        });
    }
    fontChanged(current, previows) {
        const _super = Object.create(null, {
            fontChanged: { get: () => super.fontChanged }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (current.name == 'Font C') {
                return this.connection.write(Buffer.from('\x1BM\x02', 'ascii'));
            }
            else {
                return _super.fontChanged.call(this, current, previows);
            }
        });
    }
}
exports["default"] = ControliD;
//# sourceMappingURL=ControliD.js.map

/***/ }),

/***/ 97642:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
const Epson_1 = __webpack_require__(13078);
const actions_1 = __webpack_require__(48960);
class Daruma extends Epson_1.default {
    drawer(number, _, __) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const index = {
                [actions_1.Drawer.First]: 'p',
                [actions_1.Drawer.Second]: 'p',
            };
            return this.connection.write(Buffer.from('\x1B' + index[number], 'ascii'));
        });
    }
    setAlignment(align) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const cmd = {
                [actions_1.Align.Left]: '\x1Bj0',
                [actions_1.Align.Center]: '\x1Bj1',
                [actions_1.Align.Right]: '\x1Bj2',
            };
            return this.connection.write(Buffer.from(cmd[align], 'ascii'));
        });
    }
    setStyle(style, enable) {
        const _super = Object.create(null, {
            setStyle: { get: () => super.setStyle }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (enable) {
                if (actions_1.Style.Bold == style) {
                    return this.connection.write(Buffer.from('\x1BE', 'ascii'));
                }
            }
            else {
                if (actions_1.Style.Bold == style) {
                    return this.connection.write(Buffer.from('\x1BF', 'ascii'));
                }
            }
            return _super.setStyle.call(this, style, enable);
        });
    }
    setMode(mode, enable) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (enable) {
                if (mode & actions_1.Style.DoubleWidth) {
                    yield this.connection.write(Buffer.from('\x0E', 'ascii'));
                }
                if (mode & actions_1.Style.DoubleHeight) {
                    yield this.connection.write(Buffer.from('\x1Bw1', 'ascii'));
                }
            }
            else {
                if (mode & actions_1.Style.DoubleHeight) {
                    yield this.connection.write(Buffer.from('\x1Bw0', 'ascii'));
                }
                if (mode & actions_1.Style.DoubleWidth) {
                    yield this.connection.write(Buffer.from('\x14', 'ascii'));
                }
            }
        });
    }
    feed(lines) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.connection.write(Buffer.from('\r\n'.repeat(lines), 'ascii'));
        });
    }
    initialize() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.setCodepage(this.capabilities.codepage);
            yield this.setColumns(this.capabilities.columns);
            if (this.capabilities.initialize) {
                yield this.connection.write(Buffer.from(this.capabilities.initialize, 'ascii'));
            }
            return this.fontChanged(this.font, this.font);
        });
    }
    fontChanged(current, previows) {
        const _super = Object.create(null, {
            fontChanged: { get: () => super.fontChanged }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield _super.fontChanged.call(this, current, previows);
            return this.applyCodePage();
        });
    }
    qrcode(data, size) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const len = data.length + 2;
            const pL = String.fromCharCode(len & 0xff);
            const pH = String.fromCharCode((len >> 8) & 0xff);
            const error = 'M';
            const _size = String.fromCharCode(Math.min(7, Math.max(3, size || 4)));
            yield this.connection.write(Buffer.from('\x1B\x81', 'ascii'));
            yield this.connection.write(Buffer.from(pL + pH, 'ascii'));
            yield this.connection.write(Buffer.from(_size + error, 'ascii'));
            return this.connection.write(Buffer.from(data, 'ascii'));
        });
    }
    get bitmapCmd() {
        return '\x1B*m';
    }
}
exports["default"] = Daruma;
//# sourceMappingURL=Daruma.js.map

/***/ }),

/***/ 91313:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
const Elgin_1 = __webpack_require__(75349);
class Dataregis extends Elgin_1.default {
    buzzer() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.connection.write(Buffer.from('\x07', 'ascii'));
        });
    }
}
exports["default"] = Dataregis;
//# sourceMappingURL=Dataregis.js.map

/***/ }),

/***/ 77096:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
const Elgin_1 = __webpack_require__(75349);
const actions_1 = __webpack_require__(48960);
class Diebold extends Elgin_1.default {
    buzzer() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.connection.write(Buffer.from('\x07', 'ascii'));
        });
    }
    drawer(number, on_time, off_time) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const index = {
                [actions_1.Drawer.First]: '0',
                [actions_1.Drawer.Second]: '1',
            };
            const on_time_char = String.fromCharCode(Math.min(Math.trunc(on_time / 2), 65));
            const off_time_char = String.fromCharCode(Math.min(Math.trunc(off_time / 2), 65));
            return this.connection.write(Buffer.from('\x1B&' + index[number] + on_time_char + off_time_char, 'ascii'));
        });
    }
}
exports["default"] = Diebold;
//# sourceMappingURL=Diebold.js.map

/***/ }),

/***/ 75349:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
const Epson_1 = __webpack_require__(13078);
const actions_1 = __webpack_require__(48960);
class Elgin extends Epson_1.default {
    cutter(mode) {
        const _super = Object.create(null, {
            cutter: { get: () => super.cutter }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.capabilities.model == 'I9') {
                return this.connection.write(Buffer.from('\x1DV0', 'ascii'));
            }
            return _super.cutter.call(this, mode);
        });
    }
    buzzer() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.connection.write(Buffer.from('\x1B(A\x05\x00ad\x02\x02\x01', 'ascii'));
        });
    }
    drawer(number, on_time, off_time) {
        const _super = Object.create(null, {
            drawer: { get: () => super.drawer }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.capabilities.model.startsWith('I')) {
                return _super.drawer.call(this, number, on_time, off_time);
            }
            const index = {
                [actions_1.Drawer.First]: 'v',
                [actions_1.Drawer.Second]: 'v',
            };
            const on_time_char = String.fromCharCode(Math.max(Math.min(on_time, 200), 50));
            return this.connection.write(Buffer.from('\x1B' + index[number] + on_time_char, 'ascii'));
        });
    }
    setStyle(style, enable) {
        const _super = Object.create(null, {
            setStyle: { get: () => super.setStyle }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.capabilities.model == 'I9') {
                return _super.setStyle.call(this, style, enable);
            }
            if (enable) {
                if (actions_1.Style.Bold == style) {
                    return this.connection.write(Buffer.from('\x1BE', 'ascii'));
                }
            }
            else {
                if (actions_1.Style.Bold == style) {
                    return this.connection.write(Buffer.from('\x1BF', 'ascii'));
                }
            }
            return _super.setStyle.call(this, style, enable);
        });
    }
    setMode(mode, enable) {
        const _super = Object.create(null, {
            setMode: { get: () => super.setMode }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.capabilities.model == 'I9') {
                return _super.setMode.call(this, mode, enable);
            }
            if (enable) {
                if (mode & actions_1.Style.DoubleWidth) {
                    yield this.connection.write(Buffer.from('\x1BW\x01', 'ascii'));
                }
                if (mode & actions_1.Style.DoubleHeight) {
                    yield this.connection.write(Buffer.from('\x1Bd\x01', 'ascii'));
                }
            }
            else {
                if (mode & actions_1.Style.DoubleHeight) {
                    yield this.connection.write(Buffer.from('\x1Bd\x00', 'ascii'));
                }
                if (mode & actions_1.Style.DoubleWidth) {
                    yield this.connection.write(Buffer.from('\x1BW\x00', 'ascii'));
                }
            }
        });
    }
    qrcode(data, size) {
        const _super = Object.create(null, {
            qrcode: { get: () => super.qrcode }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.capabilities.model == 'I9') {
                return _super.qrcode.call(this, data, size);
            }
            const type = String.fromCharCode(2);
            const error = 'M';
            const _size = String.fromCharCode(Math.min(255, Math.max(1, size || 4)));
            yield this.connection.write(Buffer.from('\x1Do\x00' + _size + '\x00' + type, 'ascii'));
            yield this.connection.write(Buffer.from('\x1Dk\x0B' + error + 'A,', 'ascii'));
            yield this.connection.write(Buffer.from(data, 'ascii'));
            return this.connection.write(Buffer.from('\x00', 'ascii'));
        });
    }
}
exports["default"] = Elgin;
//# sourceMappingURL=Elgin.js.map

/***/ }),

/***/ 13078:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
const actions_1 = __webpack_require__(48960);
const _1 = __webpack_require__(80706);
class Epson extends _1.Profile {
    feed(lines) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (lines > 1) {
                const count = Math.trunc(lines / 255);
                let cmd = ('\x1Bd' + String.fromCharCode(Math.min(lines, 255))).repeat(count);
                const remaining = lines - count * 255;
                if (remaining > 0) {
                    cmd += '\x1Bd' + String.fromCharCode(remaining);
                }
                return this.connection.write(Buffer.from(cmd));
            }
            else {
                return this.connection.write(Buffer.from('\r\n', 'ascii'));
            }
        });
    }
    cutter(_) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.connection.write(Buffer.from('\x1Bm', 'ascii'));
        });
    }
    buzzer() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.connection.write(Buffer.from('\x07', 'ascii'));
        });
    }
    drawer(number, on_time, off_time) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const index = {
                [actions_1.Drawer.First]: 0,
                [actions_1.Drawer.Second]: 1,
            };
            const on_time_char = String.fromCharCode(Math.min(Math.trunc(on_time / 2), 255));
            const off_time_char = String.fromCharCode(Math.min(Math.trunc(off_time / 2), 255));
            const index_char = String.fromCharCode(index[number]);
            return this.connection.write(Buffer.from('\x1Bp' + index_char + on_time_char + off_time_char, 'ascii'));
        });
    }
    setAlignment(align) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const cmd = {
                [actions_1.Align.Left]: '\x1Ba0',
                [actions_1.Align.Center]: '\x1Ba1',
                [actions_1.Align.Right]: '\x1Ba2',
            };
            return this.connection.write(Buffer.from(cmd[align], 'ascii'));
        });
    }
    setMode(mode, enable) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let byte = 0b00000000;
            if (this.font.name == 'Font B') {
                byte |= 0b00000001;
            }
            const before = byte;
            if (actions_1.Style.DoubleHeight & mode) {
                byte |= 0b00010000;
            }
            if (actions_1.Style.DoubleWidth & mode) {
                byte |= 0b00100000;
            }
            let mask = 0b00000001;
            if (enable) {
                mask = 0b00110001;
            }
            if (before != byte) {
                return this.connection.write(Buffer.from('\x1B!' + String.fromCharCode(byte & mask), 'ascii'));
            }
        });
    }
    setStyle(style, enable) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (enable) {
                if (actions_1.Style.Condensed == style) {
                    return this.connection.write(Buffer.from('\x1B\x0f', 'ascii'));
                }
                else if (actions_1.Style.Bold == style) {
                    return this.connection.write(Buffer.from('\x1BE1', 'ascii'));
                }
                else if (actions_1.Style.Italic == style) {
                    return this.connection.write(Buffer.from('\x1B4', 'ascii'));
                }
                else if (actions_1.Style.Underline == style) {
                    return this.connection.write(Buffer.from('\x1B-1', 'ascii'));
                }
            }
            else {
                if (actions_1.Style.Underline == style) {
                    return this.connection.write(Buffer.from('\x1B-0', 'ascii'));
                }
                else if (actions_1.Style.Italic == style) {
                    return this.connection.write(Buffer.from('\x1B5', 'ascii'));
                }
                else if (actions_1.Style.Bold == style) {
                    return this.connection.write(Buffer.from('\x1BE0', 'ascii'));
                }
                else if (actions_1.Style.Condensed == style) {
                    return this.connection.write(Buffer.from('\x12', 'ascii'));
                }
            }
        });
    }
    setCharSize({ width = 1, height = 1, }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            width = Math.max(1, Math.min(width, 8));
            height = Math.max(1, Math.min(height, 8));
            const n = (height - 1) | ((width - 1) << 4);
            return this.connection.write(Buffer.from(`\x1D!${String.fromCharCode(n)}`, 'ascii'));
        });
    }
    qrcode(data, size) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const tipo = '2';
            const _size = String.fromCharCode(size || 4);
            const error = '0';
            const len = data.length + 3;
            const pL = String.fromCharCode(len & 0xff);
            const pH = String.fromCharCode((len >> 8) & 0xff);
            yield this.connection.write(Buffer.from('\x1D(k\x04\x001A' + tipo + '\x00', 'ascii'));
            yield this.connection.write(Buffer.from('\x1D(k\x03\x001C' + _size, 'ascii'));
            yield this.connection.write(Buffer.from('\x1D(k\x03\x001E' + error, 'ascii'));
            yield this.connection.write(Buffer.from('\x1D(k' + pL + pH + '1P0', 'ascii'));
            yield this.connection.write(Buffer.from(data, 'ascii'));
            return this.connection.write(Buffer.from('\x1D(k\x03\x001Q0', 'ascii'));
        });
    }
    fontChanged(current, previows) {
        const _super = Object.create(null, {
            fontChanged: { get: () => super.fontChanged }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (current.name == 'Font A') {
                yield this.connection.write(Buffer.from('\x1BM\x00', 'ascii'));
            }
            else {
                yield this.connection.write(Buffer.from('\x1BM\x01', 'ascii'));
            }
            return _super.fontChanged.call(this, current, previows);
        });
    }
}
exports["default"] = Epson;
//# sourceMappingURL=Epson.js.map

/***/ }),

/***/ 85037:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
const Epson_1 = __webpack_require__(13078);
const actions_1 = __webpack_require__(48960);
class Generic extends Epson_1.default {
    setMode(mode, enable) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (enable) {
                if (mode & actions_1.Style.DoubleWidth) {
                    yield this.connection.write(Buffer.from('\x0E', 'ascii'));
                }
                if (mode & actions_1.Style.DoubleHeight) {
                    yield this.connection.write(Buffer.from('\x1Bd1', 'ascii'));
                }
            }
            else {
                if (mode & actions_1.Style.DoubleHeight) {
                    yield this.connection.write(Buffer.from('\x1Bd0', 'ascii'));
                }
                if (mode & actions_1.Style.DoubleWidth) {
                    yield this.connection.write(Buffer.from('\x14', 'ascii'));
                }
            }
        });
    }
    qrcode(data, size) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.drawQrcode(data, size);
        });
    }
}
exports["default"] = Generic;
//# sourceMappingURL=Generic.js.map

/***/ }),

/***/ 21017:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
const Elgin_1 = __webpack_require__(75349);
class Perto extends Elgin_1.default {
    buzzer() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.connection.write(Buffer.from('\x07', 'ascii'));
        });
    }
    cutter(_) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.connection.write(Buffer.from('\x1BJ\x18\x1DVB(', 'ascii'));
        });
    }
}
exports["default"] = Perto;
//# sourceMappingURL=Perto.js.map

/***/ }),

/***/ 93429:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
const Elgin_1 = __webpack_require__(75349);
class Sweda extends Elgin_1.default {
    buzzer() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.connection.write(Buffer.from('\x07', 'ascii'));
        });
    }
}
exports["default"] = Sweda;
//# sourceMappingURL=Sweda.js.map

/***/ }),

/***/ 80706:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/* provided dependency */ var Buffer = __webpack_require__(55872)["Buffer"];

Object.defineProperty(exports, "__esModule", ({ value: true }));
const tslib_1 = __webpack_require__(35745);
const actions_1 = __webpack_require__(48960);
const iconv = __webpack_require__(55515);
const QRCode = __webpack_require__(70164);
const Image_1 = __webpack_require__(37043);
const filter_1 = __webpack_require__(83772);
class Profile {
    constructor(capabilities) {
        this.capabilities = capabilities;
    }
    setStyles(styles, enable) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let properties = [
                actions_1.Style.Condensed,
                actions_1.Style.Bold,
                actions_1.Style.Italic,
                actions_1.Style.Underline,
            ];
            properties = enable ? properties : properties.reverse();
            for (const style of properties) {
                yield this.setStyle(style & styles, enable);
            }
        });
    }
    write(text, styles) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.setMode(styles, true);
            yield this.setStyles(styles, true);
            yield this.connection.write(iconv.encode(text, this._codepage.code));
            yield this.setStyles(styles, false);
            return this.setMode(styles, false);
        });
    }
    withStyle(styleConf, cb) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { width = undefined, height = undefined, bold = false, italic = false, underline = false, align = actions_1.Align.Left, } = styleConf;
            let styles = 0;
            if (bold)
                styles |= actions_1.Style.Bold;
            if (italic)
                styles |= actions_1.Style.Italic;
            if (underline)
                styles |= actions_1.Style.Underline;
            if (align !== actions_1.Align.Left) {
                yield this.setAlignment(align);
            }
            yield this.setCharSize({ width, height });
            yield this.setStyles(styles, true);
            cb();
            yield this.setStyles(styles, false);
            yield this.setCharSize({ width: 1, height: 1 });
            if (align !== actions_1.Align.Left) {
                yield this.setAlignment(actions_1.Align.Left);
            }
        });
    }
    writeln(text, styles, align) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (align !== actions_1.Align.Left) {
                yield this.setAlignment(align);
            }
            if (text.length > 0) {
                yield this.write(text, styles);
            }
            yield this.feed(1);
            if (align !== actions_1.Align.Left) {
                return this.setAlignment(actions_1.Align.Left);
            }
        });
    }
    get bitmapCmd() {
        return '\x1B*!';
    }
    draw(image) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const low = String.fromCharCode(image.width & 0xff);
            const high = String.fromCharCode((image.width >> 8) & 0xff);
            yield this.connection.write(Buffer.from('\x1B3\x10', 'ascii'));
            for (let y = 0; y < image.lines; y++) {
                const data = image.lineData(y);
                yield this.connection.write(Buffer.from(this.bitmapCmd + low + high, 'ascii'));
                yield this.connection.write(data);
                yield this.connection.write(Buffer.from('\x1BJ\x00', 'ascii'));
            }
            return this.connection.write(Buffer.from('\x1B2', 'ascii'));
        });
    }
    drawQrcode(data, size) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const buffer = yield QRCode.toBuffer(data, { scale: size });
            const image = new Image_1.default(buffer, new filter_1.Threshold());
            return this.draw(image);
        });
    }
    get connection() {
        if (this._connection) {
            return this._connection;
        }
        throw new Error('Connection must be set before priting');
    }
    set connection(value) {
        this._connection = value;
    }
    get name() {
        return this.capabilities.brand + ' ' + this.capabilities.model;
    }
    get columns() {
        return this._columns;
    }
    setColumns(value) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const font = this.fonts.find(({ columns }) => columns >= value);
            yield this.setFont(font || this.fonts.slice(-1)[0]);
            this._columns = this.font.columns >= value ? value : this.font.columns;
        });
    }
    setFont(value) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const old = this._font;
            this._font = value;
            if (old && old.name != value.name) {
                yield this.fontChanged(value, old);
                return this.applyCodePage();
            }
        });
    }
    get font() {
        return this._font;
    }
    get fonts() {
        return this.capabilities.fonts;
    }
    setCodepage(value) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const old = this._codepage;
            const codepage = this.capabilities.codepages.find(({ code }) => value == code);
            if (codepage === undefined) {
                throw new Error(`Unsupported codepage "${value}"`);
            }
            this._codepage = codepage;
            if (old && old.code != codepage.code) {
                yield this.applyCodePage();
            }
        });
    }
    applyCodePage() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.connection.write(Buffer.from(this._codepage.command, 'ascii'));
        });
    }
    fontChanged(_, __) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () { });
    }
    initialize() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.setCodepage(this.capabilities.codepage);
            yield this.setColumns(this.capabilities.columns);
            if (this.capabilities.initialize) {
                yield this.connection.write(Buffer.from(this.capabilities.initialize, 'ascii'));
            }
            return this.applyCodePage();
        });
    }
    finalize() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.connection.close();
        });
    }
}
exports.Profile = Profile;
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 29063:
/***/ ((module) => {



var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),

/***/ 3341:
/***/ ((module) => {



// do not edit .js files directly - edit src/index.jst



module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};


/***/ }),

/***/ 45564:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29063);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_index_js__WEBPACK_IMPORTED_MODULE_0__);


/***/ })

}]);